import throwUserDisplayError from './userDisplayError';

export const buildTemplateNotFoundErrorMessage = (templateLocation) => {
    const errorParts = [
        'Template not found',
        templateLocation ? `: ${templateLocation}` : '',
        '.\nThis template might have been deleted. Please verify the template name.',
    ];

    return errorParts.join('');
};

export const throwTemplateNotFoundError = (templateLocation) => {
    throwUserDisplayError(buildTemplateNotFoundErrorMessage(templateLocation));
};
